import React, { useState, useEffect } from "react"
import * as styles from "./Footer.module.scss"
import { useSiteQuery } from "../../../hooks"
import LinkGroup from "../../../LinkGroup/LinkGroup"
import { Link } from "gatsby"
import { useSubscribeToHubspot } from "../../../hooks/function/useSubscribeToHubspot"
import { RichText } from "../../RichText/RichText"
import { useSiteQueryThree } from "../../../hooks/layout/useSiteQueryThree"
import { useSiteQueryFour } from "../../../hooks/layout/useSiteQueryFour"
import LanguageSwitcher from "../../LanguageSwitcher/LanguageSwitcher"
import { useLink } from "../../../hooks/index"
import { useSubscribeToCRM } from "../../../hooks/function/useSubscribeToCRM"

const FaFacebook = () => <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"></path></svg>
const FaInstagram = () => <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 448 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"></path></svg>
const FaLinkedin = () => <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 448 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"></path></svg>
const FaYoutube = () => <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 576 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"></path></svg>
const FaXTwitter = () => <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"></path></svg>

const Footer = () => {
    const {
        footerLogo,
        footerCopyrightText,
        footerItems,
        footerPrivacy,
        footerButtonPlaceholder,
        footerButton,
        footerFirstPara,
        subscribeNewsletter,
        newsletterErrorMessage,
        footerPrivacyText,
        footerLinkedin,
    } = useSiteQuery()

    const { newsletterErrorMessage2 } = useSiteQueryThree()

    const { newsletterThankYou, languageSwitcherText } = useSiteQueryFour()

    const [emailInput, setEmailInput] = useState("")
    const [consentChecked, setConsentChecked] = useState(false)
    const [formError, setFormError] = useState("")
    const [showThankYou, setShowThankYou] = useState(false)
    const [ipAddress, setIpAddress] = useState("")
    const [consentDateTime, setConsentDateTime] = useState(
        new Date().toISOString()
    )

    const [submitForm, { loading, error }] = useSubscribeToCRM()

    useEffect(() => {
        fetch("https://api.ipify.org?format=json")
            .then(res => res.json())
            .then(data => setIpAddress(data.ip))
            .catch(() => setIpAddress(""))
    }, [])

    const submitHandler = async e => {
        e.preventDefault()

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if (!emailInput || !emailRegex.test(emailInput)) {
            setFormError(newsletterErrorMessage)
            return
        }

        if (!consentChecked) {
            setFormError(newsletterErrorMessage2)
            return
        }

        setFormError("")

        const payload = {
            ip_address: ipAddress,
            consent_given: consentChecked,
            consent_text: footerPrivacy.footerPrivacy,
            consent_date_time: consentDateTime,
        }

        await submitForm({
          email: emailInput,
          ip_address: ipAddress,
          consent_given: consentChecked,
          consent_text: footerPrivacy.footerPrivacy,
          consent_date_time: consentDateTime,
        })

        setEmailInput("")
        setConsentChecked(false)
        setShowThankYou(true)
    }

    useEffect(() => {
        if (showThankYou) {
            const timer = setTimeout(() => setShowThankYou(false), 3000)
            return () => clearTimeout(timer)
        }
    }, [showThankYou])

    return (
        <footer
            className="bg-primary-blue c-padding"
            aria-label="Site footer"
            role="contentinfo"
        >
            <div className={`container flex flex-col ${styles.footerContainer}`}>
                <div className={`flex ${styles.footerMenu}`}>
                    {/* Col1 */}
                    <div className={styles.col1}>
                        <Link to={`${useLink("/")}`} aria-label="Footer Logo">
                            <img
                                src={footerLogo?.file.url}
                                alt={footerLogo?.title}
                                height={footerLogo?.height}
                                width={footerLogo?.width}
                                className={styles.footerLogo}
                                loading="lazy"
                            />
                        </Link>
                        {/* <p className={styles.paraSection}>
              <RichText content={footerFirstPara} />
            </p> */}
                    </div>

                    {/* Col2 */}
                    <div className={`c-padding ${styles.col2}`}>
                        <h2 className="sr_only">Site Footer Menu</h2>
                        {footerItems?.map(
                            (item, index) =>
                                item.__typename === "ContentfulComponentLinkGroup" && (
                                    <LinkGroup key={index} item={item} />
                                )
                        )}

                        {/* Newsletter */}
                        <div
                            className={styles.col3}
                            aria-labelledby="newsletter-title"
                        >
                            <h2 className="sr_only" id="newsletter-title">Newsletter Subscription</h2>
                            <p className={`global-spacing-bottom ${styles.footerPrivacy}`}>{subscribeNewsletter}</p>
                            <form className={styles.form} onSubmit={submitHandler}>
                                <div className={styles.formData}>
                                    {showThankYou ? (
                                        <p className={styles.thankYou}>{newsletterThankYou}</p>
                                    ) : (
                                        <>
                                            <input
                                                type="email"
                                                name="email"
                                                id="newsletter-email"
                                                aria-label="Email"
                                                autoComplete="email"
                                                placeholder={footerButtonPlaceholder}
                                                className={`bg-white ${styles.email}`}
                                                onChange={e => setEmailInput(e.target.value)}
                                                value={emailInput}
                                            />

                                            <button
                                                type="submit"
                                                className={`activeButton ${styles.joinButton}`}
                                                disabled={loading || !consentChecked}
                                                aria-label="Submit the join us form"
                                            >
                                                {footerButton}
                                            </button>
                                        </>
                                    )}
                                </div>
                                {formError && <div className={styles.formError}>{formError}</div>}
                                <div className={styles.subscribe}>
                                    <label
                                        htmlFor="newsletter-consent"
                                        className={styles.consentLabel}
                                    >
                                        <input
                                            type="checkbox"
                                            id="newsletter-consent"
                                            name="newsletterConsent"
                                            checked={consentChecked}
                                            onChange={e => setConsentChecked(e.target.checked)}
                                            className={styles.checkbox}
                                        />
                                      
                                        <RichText content={footerPrivacyText} />
                                    </label>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <LanguageSwitcher languageSwitcherText={languageSwitcherText} />

                {/* Bottom */}
                <div className={`flex justify-between ${styles.copyrightText}`}>
                    <p>{footerCopyrightText}</p>
                    <ul className={styles.socialIcons} aria-label="Social media">
                        <li>
                            <a
                                href="https://www.instagram.com/digitupindia/"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Visit our Instagram"
                            >
                                <FaInstagram />
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://www.facebook.com/digitupindia"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Visit our Facebook"
                            >
                                <FaFacebook />
                            </a>
                        </li>
                        <li>

                            <a
                                href={footerLinkedin}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Visit our LinkedIn"
                            >
                                <FaLinkedin />
                            </a>

                        </li>
                        <li>
                            <a
                                href="https://www.youtube.com/@digitupIndia"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Visit our YouTube"
                            >
                                <FaYoutube />
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://x.com/Digitupind"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Visit our X (formerly Twitter)"
                            >
                                <FaXTwitter />
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </footer>
    )
}
export default Footer
